import type { ApiSuccessResponse, ExtendedFetchOptions } from '@/types/api-client'
import type { AddAccountPayload } from '@/types/api-client/add-account'

export function createAddAccountApi(
	request: <T>(endpoint: string, options?: ExtendedFetchOptions) => Promise<T | null>
) {
	return {
		create: (payload: AddAccountPayload, options: ExtendedFetchOptions = {}) => {
			return request<ApiSuccessResponse>('/auth/addAccount', {
				method: 'POST',
				body: payload,
				...options
			})
		}
	}
}
